import {Box, Text} from '@mantine/core';
import type React from 'react';
import {MdClose, MdOpenInNew} from 'react-icons/md';
import {GTAG_CMD_EVENT, GTAG_EVENT_NAMES} from '../../../config/constants/gtag';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';

type Props = {
  message: string;
  url: string;
  onClose: () => void;
};

export const LinkNotice: React.FC<Props> = ({message, url, onClose}) => {
  const {isPC} = useMediaQuery();

  const handlePressLink = () => {
    if (window?.gtag) {
      window.gtag(GTAG_CMD_EVENT, GTAG_EVENT_NAMES.CLICK_LINK_NOTICE, {
        url,
        message,
      });
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      {isPC ? (
        <Box className="flex flex-row items-center gap-12">
          <Box className="flex items-center gap-8 flex-1 min-w-0">
            <Box className="relative flex-shrink-0 w-8 h-8">
              <Box className="absolute inset-0 rounded-full bg-notification animate-ping opacity-75" />
              <Box className="relative w-8 h-8 rounded-full bg-notification" />
            </Box>
            <Text className="text-base text-primary font-bold truncate">
              {message}
            </Text>
          </Box>
          <Box className="flex flex-row items-center gap-8 flex-shrink-0">
            <Box
              className="cursor-pointer flex items-center gap-4 border-primary border-[1px] bg-white rounded-[8px] py-8 px-16 hover:bg-primary hover:text-white transition-colors group"
              onClick={handlePressLink}
            >
              <Text className="text-sm text-primary font-bold group-hover:text-white">
                詳しくはこちら
              </Text>
              <MdOpenInNew
                size={14}
                className="text-primary group-hover:text-white"
              />
            </Box>
            <Box
              className="w-24 h-24 flex items-center justify-center rounded-full bg-black-3 cursor-pointer"
              onClick={onClose}
            >
              <MdClose size={24} color="white" />
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          className="flex flex-row items-center gap-8"
          onClick={handlePressLink}
        >
          <Box className="relative flex-shrink-0 w-8 h-8">
            <Box className="absolute inset-0 rounded-full bg-notification animate-ping opacity-75" />
            <Box className="relative w-8 h-8 rounded-full bg-notification" />
          </Box>
          <Text className="text-sm text-primary font-bold flex-1 min-w-0 truncate">
            {message}
          </Text>
          <Box
            className="flex-shrink-0"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            <MdClose size={16} className="text-black-3" />
          </Box>
        </Box>
      )}
    </>
  );
};
